import {CommandClause, CPCLCommand} from "@psdk/frame-father";
import {BasicCPCLArg} from "./basic";
import {CPageWidth} from "./pagewidth";
import {CGap} from "./gap";
import {CForm} from "./form";
import {CPrint} from "./print";
import {CMode} from "../types";

export class CFeed extends BasicCPCLArg<CFeed> {

  clause(): CommandClause {
    super.append(new CPageWidth({width: 576}))
      .append(new CGap())
      .append(new CForm())
      .append(new CPrint({mode: CMode.NORMAL}));
    return CPCLCommand.with(this.header()).clause();
  }

  header(): string {
    return '! 0 200 200 0 1';
  }
}



